import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';


/**
 * Reusable quantity stepper (− N +). Used for the number of plants of a cohort
 * (add, edit, redistribute). `min` (default 1) and optional `max` bounds.
 * `editable` : le nombre se tape aussi au clavier (50 oignons sans 50 appuis).
 * Usage: `<vw-quantity-stepper [(value)]="nbPlants" [min]="1" [max]="20" unitLabel="plants" />`
 */
@Component({
  selector: 'vw-quantity-stepper',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './quantity-stepper.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './quantity-stepper.component.scss',
})
export class QuantityStepperComponent {
  @Input() value = 1;
  @Input() min = 1;
  @Input() max?: number;
  @Input() unitLabel?: string;
  @Input() editable = false;
  /** Nom du champ et des boutons pour le lecteur d'écran (« Nombre de plants », « Un plant de plus »). */
  @Input() inputLabel?: string;
  @Input() decreaseLabel?: string;
  @Input() increaseLabel?: string;
  @Output() valueChange = new EventEmitter<number>();

  get canIncrement(): boolean {
    return this.max == null || this.value < this.max;
  }

  get canDecrement(): boolean {
    return this.value > this.min;
  }

  increment(): void {
    if (!this.canIncrement) return;
    this.value = this.value + 1;
    this.valueChange.emit(this.value);
  }

  decrement(): void {
    if (!this.canDecrement) return;
    this.value = this.value - 1;
    this.valueChange.emit(this.value);
  }

  /** Nombre tapé : ramené dans les bornes ; un champ vide ou illisible reprend la valeur d'avant. */
  onTyped(input: HTMLInputElement): void {
    const typed = Math.floor(Number(input.value));
    if (input.value.trim() === '' || !Number.isFinite(typed)) {
      input.value = String(this.value);
      return;
    }
    const bounded = Math.max(this.min, this.max == null ? typed : Math.min(this.max, typed));
    input.value = String(bounded);
    if (bounded === this.value) return;
    this.value = bounded;
    this.valueChange.emit(this.value);
  }
}
